module.exports = {
  theme: {
    mainsubcategorysbackground: "#FFFFFF",
    btnmainbackground: "#000",
    btnmaintext: "#FFFFFF",
    btnsecondbackground: "#efefef",
    btnsecondtext: "#1E1F1C",
    btnthirdbackground: "#E7E7E7",
    btnthirdtext: "#000",
    btnthirdicon: "#CFD7F7",
    btnoutlineborder: "#E7E7E7",
    btnoutlinebackground: "#FFF",
    btnoutlinetext: "#1E1F1C",
    btnoutlineicon: "#CFD7F7",
    btnoutlineactiveborder: "#192040",
    btnoutlineactivebackground: "#E7E7E7",
    btnoutlineactivetext: "#192040",
    btnoutlineactiveicon: "#CFD7F7",
    btndestructivebackground: "#FEE3E3",
    btndestructivetext: "#F86262",
    btndestructiveicon: "#FBA2A2",
    bordermain: "#2B3667",
    borderonbackground: "#CFD7F7",
    backgroundmain: "#1E1F1C",
    backgroundmodal: "#00000030",
    backgroundmodallayover: "#00000030",
    listsborder: "",
    listsbackground: "#FFFFFF",
    liststext: "#000",
    listscheckbackground: "#CFD7F7",
    listscheckborder: "#CFD7F7",
    listscheckicon: "#192040",
    listactiveprice: "#9D9D9D",
    listactivepricetext: "#ffffff",
    listsactivebackground: "#E7E7E7",
    listsactivetext: "#192040",
    listsactivecheckbackground: "#192040",
    listsactivecheckborder: "#192040",
    listsactivecheckicon: "#CFD7F7",

    text: "#1E1F1C",
    titlemain: "#707070",
    titlesecondary: "#CFD7F7",
    titlethird: "#CFD7F7",
    processtekst: "#000000",
    paymentloadingbackground: "#e2e8f0",
    buttonimgcolors: "#000000",
    selectitemcolor: "#000000",
    itembackground: "#efefef",

    kioskarrow: "#000000",
    kioskarrowbackground: "#e2e8f0",
    kioskborder: "border-black",
    kioskdetailbackground: "#e2e8f0", // background color next-prev button in navigation and the background of th
    kioskdetailtext: "#000000",
    kioskcurrentcatborder: "#000000", // line in addition screen
    kioskmodifieritemborder: "#000000",
    kiosklastitembackgroundcolor: "#FFFFFF",
    kiosklastitemtitle: "#000000",
    kiosklastitemprice: "#000000",

    // bavet
    // kioskarrow: "#eb5252",
    // kioskarrowbackground: "#fad4d4",
    // kioskborder: "border-red-500",
    // kioskdetailbackground: "#e2e8f0",
    // kioskdetailtext: "#FFFFFF",
    // kioskcurrentcatborder: "#e51e1e",
    // kiosklastitembackgroundcolor: "#FFFFFF",
    // kiosklastitemtitle: "#e51e1e",
    // kiosklastitemprice: "#e51e1e",
    iconkioskhomepagecolor: "#000", // icons (house, car, left corner of the app)
    textkioskhomepagecolor: "#000", // tekst on the kiosk homepage screen inside the options
    paymentfloatbackground: "#dbdbdb", // background color of the add to cart button (bottom)
    listactiveborderprice: "#5490f8",
    kioskcategorytitle: "#000", // category title
    kioskitemoverviewborder: "#000", // border inside the cart overview
    kioskpricecolor: "#000", // total price for 1 item with additions inside the cart overview
    totalpricecolor: "#000", // total price of all products in the cart overview
    totalpricetext: "#000", // color of the text 'total' inside the cart overview
    orderdetailsuccesfullpayment: "#5490f8",// color of succesfull payment in the orderdetails page
    orderdetailordernumber: "#000", //color of the text inside the orderdetailscreen
    // orderdetailorderbackground: "#5490f8", // background color of the orderdetails in the orderdetail page
    gobackbutton: "#dbdbdb", // go back button background color inside the cart process
    gobackbuttontext: "#000", // go back button text color inside the cart process
    upsellingitemcolor: "#5490f8",
    additionaddbackground: "#FFF", // addition add button background color
    kioskadditiontitlecolor: "#000", // addition title color
    kiosktotalprice: "#000", // color of the total price (bottom)
    kiosktotalcolor: "#9c9c9c", // color of the total text (bottom)
    deleteiconkioskbackground: "#5490f8",
    kioskstartbackgroundbutton: "#dbdbdb", // background on the kiosk homepage screen inside the options
    kioskcancelbuttoncolor: "#000", // cancel order button text color (bottom)
    kioskcancelbuttonbackground: "#9c9c9c", // cancel order button background color (bottom)
    itemdescription: "#000", // item description inside addition modal
    kioskbordercolor: "#dbdbdb", // kiosk navigation border
    kiosknaviconcolor: "#000", // arrow color from next-prev buttons in carrousel
    kiosknavactivebarcolor: "#000", // color of the bar under the active category
    addmoreitemsiconbackground: "#000000", // background of + / - buttons inside additions
    kioskplusminbuttons: "#FFF", // + and - arrows inside the additions
    addmoreitemsicon: "#FFFFFF",
    addmoreitemsnumber: "#000000",
    kioskkeyboardbackgroundcolor: "#000",
    kioskkeyboardtextcolor: "#FFF",

    cardmainbackground: "#2B3667",
    cardsecondarybackground: "#1E1F1C",
    paymentbtnbackground: "#000",
    paymentbtntext: "#FFFFFF",
    paymentfloatactivebackground: "#192040",
    tipsfloatbackground: "#2B3667",
    tabsbackground: "#2B3667",
    tabstext: "#CFD7F7",
    tabsactivebackground: "#CFD7F7",
    tabsactivetext: "#2B3667",
    tabsicon: "#FFFFFF",
    summbackground: "#2B3667",
    summchildrenbackground: "#F8FAFF",
    stepsbackground: "#EFEFEF",
    stepstext: "#2B3667",
    stepsnumber: "#FFFFFF",
    stepsline: "#2B3667",
    stepsactivebackground: "#000000",
    stepsactivetext: "#FFF",
    stepsactivenumber: "#FFFFFF",
    timeslotactivecolor: "#404040",
    orderdetailorderbackground: "#e0e0e0",
    orderdetailordercolor: "#000",

    // Discount
    discountbtnbackgroundcolor: "#F68484",
    discountlistbackgroundcolor: "#fdeded",
    discountwarningcolor: "#F68484",
    discountwarningaccentcolor: "#F68484",
    discountlistitemvaluecolor: "#c04d2e",
    discountlistitemdeletebuttonbackgroundcolor: "#fee3e3",
    discountlistitemdeletebuttoniconcolor: "#fba2a2",
    discountappliedtotalcolor: "#f68484",
  },
};
